module.exports = __webpack_public_path__ + "static/media/social.b1841475.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/social.png
 ** module id = 179
 ** module chunks = 0
 **/